import model from '../mixins/model';

export default {
    mixins: [model],
    form: true,
    model() {
        return {
            username: null,
            password: null
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();

            this.dispatch((resolve,reject) => {

                this.$auth.login(this.model).then(resolve).catch(reject);

            }).then((status) => {

                if (status === 'VERIFIED')
                    this.$router.push({name:"agent"});
            }).catch(() => {});
        }
    }
}
